<template>
  <v-scroll-y-transition v-if="settings.show_legend && settings.with_rates" >
    <div id="legend-row" class="d-flex flex-row justify-end d-xs-none">
      <div class="d-flex flex-row">
        <span class="subtitle">
          <v-icon>mdi-map-legend</v-icon>{{ $lang('calendar.legend.title') }}:
        </span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/cutoff.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.cutoff') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/min-stay.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.min_stay') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/max-stay.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.max_stay') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/no-availability.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.no_availability') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/no-checkin.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.checkin_forbidden') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/no-checkout.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.checkout_forbidden') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/not-sellable-date.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.single_date_no_sellable') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/open-to-sales.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.sellable') }}</span>
      </div>
      <div class="d-flex flex-row">
        <span class="legend-image">
          <v-img src="/img/calendar/stop-sell.svg" contain />
        </span>
        <span class="legend-text">{{ $lang('calendar.legend.stop_sell') }}</span>
      </div>
    </div>
  </v-scroll-y-transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Legend",
  computed: {
    ...mapState({
      settings: state => state.calendarSettings.current,
    }),
  }
};
</script>

<style>
#legend-row {
  padding-top: 10px;
  padding-bottom: 5px;
}
.legend-image {
  width: 20px;
  height: 15px;
  margin-right: 5px;
  margin-left: 7px;
}
.legend-text {
  font-size: 10px;
}
</style>